import { useEffect, useState } from "react";
import "./filter.css"
import { FaFilter } from "react-icons/fa6";
import { FaX } from "react-icons/fa6";
import RangeSlider from 'rsuite/RangeSlider';
import 'rsuite/RangeSlider/styles/index.css';
import CurrencyFormat from "react-currency-format"
import { AiOutlineDown } from "react-icons/ai";
import { useGlobalContext } from "../../context";


function Filter() {
    const { totalFilter, setTotalFilter, handleDeleteFilter } = useGlobalContext()
    const [showPriceRange, setShowPriceRange] = useState(true)
    const [showCat, setShowCat] = useState(false)
    const [showColor, setShowColor] = useState(false)
    const [showProCat, setShowProCat] = useState(false)
    const [showFiltering, setShowFiltering] = useState(false)
    const [catCheck, setCatCheck] = useState([
        { id: 1, checked: false, label: "کت شلوار" },
        { id: 2, checked: false, label: "پیراهن" },
        { id: 3, checked: false, label: "ست" },
        { id: 4, checked: false, label: "دامن" },
        { id: 5, checked: false, label: "مانتو" },
    ])
    const [colorCheck, setColorCheck] = useState([
        { id: 1, checked: false, label: "شیری" },
        { id: 2, checked: false, label: "سفید" },
        { id: 3, checked: false, label: "قرمز" },
        { id: 4, checked: false, label: "آبی" },
        { id: 5, checked: false, label: "بنفش" },
    ])
    const [proCat, setProCat] = useState([
        { id: 1, checked: false, label: "جدیدترین" },
        { id: 2, checked: false, label: "پربازدیدترین" },
        { id: 3, checked: false, label: "تخفیف" },
        { id: 4, checked: false, label: "گرون ترین" },
        { id: 5, checked: false, label: "ارزان ترین" },
    ])
    const handleCheckBox = (id) => {
        const updatedCheckBox = catCheck.map((item) => {
            if (item.id == id) {
                setTotalFilter({ ...totalFilter, cat: item.label })
                return { ...item, checked: true }
            } else {
                return { ...item, checked: false }
            }
        })
        setCatCheck(updatedCheckBox)
    }
    const handleProCat = (id) => {
        const updatedCheckBox = proCat.map((item) => {
            if (item.id == id) {
                return { ...item, checked: true }
            } else {
                return { ...item, checked: false }
            }
        })
        setProCat(updatedCheckBox)
    }
    const handlecolor = (id) => {
        const updatedCheckBox = colorCheck.map((item) => {
            if (item.id == id) {
                setTotalFilter({ ...totalFilter, color: item.label })
                return { ...item, checked: true }
            } else {
                return { ...item, checked: false }
            }
        })
        setColorCheck(updatedCheckBox)
    }
    const handleRange = (value) => {
        setTotalFilter({ ...totalFilter, min: value[0], max: value[1] })
    }

    return (
        <div className="filter">
            <div className="filter-container">
                <div className="filter-part">
                    <button style={{padding : "5px"}} onClick={() => setShowFiltering(true)}>
                        فیلتر
                        <FaFilter />
                    </button>
                </div>
                <div className={showFiltering ? "filtering show" : "filtering"}>
                    <div className="filtering-container">
                        <div className="filtring-content">
                            <ul>
                                <li className="exit-filtering" onClick={() => setShowFiltering(false)}><FaX /></li>
                                <li className={showPriceRange ? "price-filtering show" : "price-filtering"}>
                                    <span onClick={() => setShowPriceRange(!showPriceRange)}>
                                        قیمت :
                                        <AiOutlineDown size={13} color="gray" />
                                    </span>
                                    <div className="price-range">
                                        <RangeSlider defaultValue={[0, 10000000]} min={1} max={10000000} onChange={(value) => handleRange(value)} />
                                        <div className="price-rate">
                                            <span><CurrencyFormat
                                                thousandSeparator={true}
                                                value={totalFilter.max}
                                                displayType="text">
                                            </CurrencyFormat></span>
                                            <span><CurrencyFormat
                                                thousandSeparator={true}
                                                value={totalFilter.min}
                                                displayType="text">
                                            </CurrencyFormat></span>
                                        </div>
                                    </div>
                                </li>
                                <li className={showCat ? "cat-filtring show" : "cat-filtring"}>
                                    <span onClick={() => setShowCat(!showCat)}>
                                        دسته بندی لباس:
                                        <AiOutlineDown size={13} color="gray" />
                                    </span>
                                    <div className="cat-items">
                                        <ul>
                                            {
                                                catCheck.map((item, i) => {
                                                    return (
                                                        <li key={i}>
                                                            <span>{item.label}</span>
                                                            <input
                                                                type="checkbox"
                                                                checked={item.checked}
                                                                onChange={() => handleCheckBox(item.id)} />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </li>
                                <li className={showProCat ? "pro-cat show" : "pro-cat"}>
                                    <span onClick={() => setShowProCat(!showProCat)}>
                                        دسته بندی محصول :
                                        <AiOutlineDown size={13} color="gray" />
                                    </span>
                                    <div className="pro-cat-items">
                                        <ul>
                                            {
                                                proCat.map((item, i) => {
                                                    return (
                                                        <li key={i}>
                                                            <span>{item.label}</span>
                                                            <input
                                                                type="checkbox"
                                                                checked={item.checked}
                                                                onChange={() => handleProCat(item.id)} />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </li>
                                <li className={showColor ? "color-filtring show" : "color-filtring"}>
                                    <span onClick={() => setShowColor(!showColor)}>
                                        رنگ :
                                        <AiOutlineDown size={13} color="gray" />
                                    </span>
                                    <div className="color-items">
                                        <ul>
                                            {
                                                colorCheck.map((item, i) => {
                                                    return (
                                                        <li key={i}>
                                                            <span>{item.label}</span>
                                                            <input
                                                                type="checkbox"
                                                                checked={item.checked}
                                                                onChange={() => handlecolor(item.id)} />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </li>

                                <li className="sub-filter">
                                    <button onClick={() => handleDeleteFilter()} className="sub-filter-btn">
                                        حذف فیلتر
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Filter;